<template>
  <div>
    <div class="font-secondary heading each-row">{{name}}</div>
    <div class="each-row regular-font">{{date}}</div>
    <div class="each-row regular-font rich-text-editor-custom-css" v-html="description" />
    <div class="each-row faded regular-font">{{tags}}</div>
    <div class="each-row big-font">{{status}}</div>
  </div>
</template>

<script>
    export default {
        name: "StudyCard",
        props:['study'],

        computed: {
          name(){
            return this.study.name
          },
          date(){
            let date = new Date(this.study.dateCreated)
            let months = {0: 'Jan', 1:'Feb', 2:'Mar', 3:'Apr', 4:'May', 5:'Jun', 6:'Jul', 7:'Aug', 8:'Sep', 9:'Oct', 10:'Nov', 11:'Dec'}
            let month = months[date.getMonth()]
            let day = date.getDate()
            let year = date.getFullYear()
            let formattedBirthday = `${month} ${day}, ${year}`
            return formattedBirthday
          },
          description(){
            return this.study.studyPurpose
          },
          tags(){
            return this.study.tags.split(",").join(", ")
          },
          status(){
            let closed = this.study.closed
            let maxParticipantsReaches = this.study.maxParticipantsReached
            let status = closed || maxParticipantsReaches ? 'Closed' : 'Open'
            return `Status: ${status}`
          },
        },

    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .heading{
    color: $red-2;
    font-weight: bold;
    font-size: 13px;
  }

  .each-row{
    padding: 1% 0;
  }

  .regular-font{
    font-size: 14px;
  }

  .big-font{
    font-size: 15px;
  }

  .faded{
    color: $gray-3;
  }

</style>
